import { render, staticRenderFns } from "./Banner006PrimerosCuidados.vue?vue&type=template&id=35c778a4"
import script from "./Banner006PrimerosCuidados.vue?vue&type=script&lang=js"
export * from "./Banner006PrimerosCuidados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports